import { useState, useCallback } from 'react'
import { NoSaleReasonStat } from '../types'
import { getNoSaleReasonStatistics } from '../services'

export const useNoSaleReasons = (pluginspaceId: number) => {
  const [reasons, setReasons] = useState<NoSaleReasonStat[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const loadReasonStatistics = useCallback(
    async (days: number = 7) => {
      try {
        setLoading(true)
        setError(null)
        const data = await getNoSaleReasonStatistics(pluginspaceId, days)
        setReasons(data)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erro ao carregar motivos')
        setReasons([])
      } finally {
        setLoading(false)
      }
    },
    [pluginspaceId]
  )

  return {
    reasons,
    loading,
    error,
    loadReasonStatistics,
  }
}
